import { types } from './reconciliacaoPixAutomatico.actions'
import { Reducer } from '../../services/reducer.factory'
import storage from '../../services/stoage.service'

const initialState = {
  id: 'reconciliacaopixautomatico',
  records: [],
  selectedRecords: [],
  resultado: null,
  usaListDto: true,
  messages: {},
}

const reducer = new Reducer(initialState, types)

export function CRUDReconciliacaoPixAutomaticoReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels('reconciliacaopixautomatico')
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  switch (action.type) {
    case types.SET_RESULTADO:
      return { ...state, resultado: action.payload }
    default:
      return state
  }
}
